import React from 'react';
import styles from './index.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.packContainer}>
          <img
            className={styles.bg}
            src={getImageFromS3('images/kv7/leafs-bg.gif')}
            alt="container-bg"
          />
          <img
            className={styles.logo}
            src={getImageFromS3('images/kv7/logo.png')}
            alt="logo"
          />
          <img
            className={styles.packs}
            src={getImageFromS3('images/kv7/packs.gif')}
            alt="packs"
          />
          <img
            className={styles.packsShadow}
            src={getImageFromS3('images/kv7/packs-shadow.png')}
            alt="packs-shadow"
          />
        </div>
        <div className={styles.characteristicContainer}>
          <img
            className={styles.bg}
            src={getImageFromS3('images/kv7/bg.png')}
            alt="characteristic-bg"
          />
          <img
            className={styles.yellowBg}
            src={getImageFromS3('images/kv7/yellow-bg.png')}
            alt="yellow-bg"
          />
          <img
            className={styles.packsTitle}
            src={getImageFromS3('images/kv7/packs-title.png')}
            alt="packs-title"
          />
          <img
            style={{ width: '100%', zIndex: 1, position: 'relative' }}
            src={getImageFromS3('images/kv7/quality.png')}
            alt="quality"
          />
          <img
            style={{
              width: '100%',
              zIndex: 1,
              position: 'relative',
              marginTop: 30
            }}
            src={getImageFromS3('images/kv7/filter.png')}
            alt="filter"
          />
          <img
            style={{
              width: '100%',
              zIndex: 1,
              position: 'relative',
              marginTop: 20
            }}
            src={getImageFromS3('images/kv7/qr.png')}
            alt="qr"
          />
          <div className={styles.surveyContainer}>
            <p className={styles.title}>
              Хочеш отримувати новини про продукцію?
            </p>
            <p className={styles.description}>
              Проходь невелике опитування та отримуй <b>30 грн</b> на мобільний
              за витрачений час.
            </p>
            <button
              onClick={() =>
                window.open(
                  'https://www.scanpack.com/ua-reg?utm_campaign=25UA-KV7&returned=true',
                  '_blank'
                )
              }
            >
              Пройти опитування
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
